// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__mWtqT","container":"LayoutSideNavigation_container__2kMfX","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__18SEB"};